import React, { createContext, useState } from "react";

export const CashManagementBusinessFormContext = createContext({
  setValue: () => {},
  resetValue: () => {},
  value: {
    hasAnExistingAccount: "",
    preferredStore: "",
    other: "",
    typeOfBusiness: "",
    inquireAbout: [],
    primaryMobileNumber: "",
    preferredDay: [null, null],
    businessName: "",
    name: "",
    email: "",
    timeIn: "08:30",
    timeTo: "09:00",
    other: "",
    purposeLoan: "",
    loanAmount: "",
  },
});

const CashManagementBusinessFormContextProvider = ({ children }) => {
  const [value, setValue] = useState({
    hasAnExistingAccount: "",
    preferredStore: "",
    other: "",
    typeOfBusiness: "",
    inquireAbout: [],
    primaryMobileNumber: "",
    preferredDay: [null, null],
    businessName: "",
    name: "",
    email: "",
    timeIn: "08:30",
    timeTo: "09:00",
    other: "",
    purposeLoan: "",
    loanAmount: "",
  });

  const updateValue = (val) => {
    setValue(val);
  };

  const resetValue = () => {
    setValue({
      hasAnExistingAccount: "",
      preferredStore: "",
      other: "",
      typeOfBusiness: "",
      inquireAbout: [],
      primaryMobileNumber: "",
      preferredDay: [null, null],
      businessName: "",
      name: "",
      email: "",
      timeIn: "08:30",
      timeTo: "09:00",
      other: "",
      purposeLoan: "",
      loanAmount: "",
    });
  };
  return (
    <CashManagementBusinessFormContext.Provider
      value={{
        value,
        setValue,
        updateValue,
        resetValue,
      }}
    >
      {children}
    </CashManagementBusinessFormContext.Provider>
  );
};

export default CashManagementBusinessFormContextProvider;
